import { Link, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { navigation, ProductNav } from "./navigation";
import { DocSearch } from "../components/DocSearch";

interface SidebarProps {
  product: string;
}

export function Sidebar({ product }: SidebarProps) {
  const location = useLocation();
  const nav = navigation.find((n) => n.product === product);
  if (!nav) return null;

  return (
    <aside
      aria-label="Documentation sections"
      className="hidden md:block w-[220px] shrink-0 border-r border-border self-start sticky top-24 max-h-[calc(100dvh-96px)] overflow-y-auto py-5 pr-3"
    >
      <Link
        to="/docs"
        className="flex items-center gap-2 text-xs text-text-faint hover:text-text-muted mb-3 pl-3 transition-colors"
      >
        <ArrowLeft size={13} aria-hidden="true" />
        All docs
      </Link>

      <div className="mb-5">
        <DocSearch scope={nav.product} />
      </div>

      {nav.sections.map((section) => (
        <nav key={section.title} aria-label={section.title} className="mb-5">
          <p className="text-[10px] font-medium tracking-widest uppercase text-text-faint pl-3 mb-1.5">
            {section.title}
          </p>
          {section.items.map((item) => {
            const isActive = location.pathname === item.href;
            return (
              <Link
                key={item.href}
                to={item.href}
                aria-current={isActive ? "page" : undefined}
                className={`flex items-center gap-2 text-sm px-3 py-1.5 rounded-md transition-colors ${
                  isActive
                    ? "bg-primary-dim text-primary-text font-medium border-r-2 border-primary"
                    : "text-text-muted hover:text-text hover:bg-bg-hover"
                }`}
              >
                {item.label}
              </Link>
            );
          })}
        </nav>
      ))}
    </aside>
  );
}
